import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import Pagination from "../Layout/Pagination";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";
import AlarmCancel from "./AlarmCancel";
import GifticonRefund from "./GifticonRefund";
import UpdateCashInfo from "./UpdateCashInfo";

const OrderInfoBox = ({ handleClickX, paymentId }) => {
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const offset = 5;

  const [clickUpdateCashInfo, setClickUpdateCashInfo] = useState(false);
  const [clickCancelOrder, setClickCancelOrder] = useState(false);
  const [clickRefund, setClickRefund] = useState(false);

  const [order_item_list, setOrder_item_list] = useState([]);
  const [total_item, setTotal_item] = useState(0);
  const [orderInfo, setOrderInfo] = useState({});

  const getOrderDetail = async () => {
    try {
      const body = { page, offset, paymentId };
      const res = await postJson("/dashboard/gifticonOrder/getDetail", body, navigate);

      if (res.code === 200) {
        setTotal_item(res.data.count);
        setOrder_item_list(res.data.rows);
        setOrderInfo(res.data.orderInfo);
      }
    } catch (error) {
      console.error("주문 상세 가져오기 중 에러:", error);
    }
  };

  const handleCancelOrder = async () => {
    try {
      const body = { paymentId };
      const res = await postJson(
        "/dashboard/gifticonOrder/transferCancel",
        body,
        navigate
      );
      if (res.code === 200) {
        console.log("주문 취소 완료");
        setClickCancelOrder(false);
      }
    } catch (error) {
      console.error("주문 취소 중 에러:", error);
    }
  };

  useEffect(() => {
    getOrderDetail();
  }, [page, clickUpdateCashInfo, clickCancelOrder]);
  return (
    <Box>
      {clickCancelOrder && (
        <AlarmCancel
          title="주문을 취소하시겠습니까?"
          subtitle="입금 대기중인 주문을 취소하시겠습니까?"
          handleCancel={handleCancelOrder}
          handleClickX={() => setClickCancelOrder(false)}
        />
      )}
      {clickUpdateCashInfo && (
        <UpdateCashInfo
          handleClickX={() => setClickUpdateCashInfo(false)}
          paymentId={paymentId}
        />
      )}
      {clickRefund && (
        <GifticonRefund
          handleClickBack={() => setClickRefund(false)}
          handleClickX={() => {
            setClickRefund(false);
            handleClickX();
          }}
          paymentId={paymentId}
        />
      )}
      <div className="hrz-wrapper">
        <p className="bold-text" style={{ fontSize: "32px" }}>
          주문 상세
        </p>
        <IconCrossRound
          fill="#b0b0b0"
          style={{ marginLeft: "auto", cursor: "pointer" }}
          onClick={handleClickX}
        />
      </div>

      <div
        className="scrollView"
        style={{ marginTop: "40px", height: "506px" }}
      >
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "191px 179px 396px 59px",
          }}
        >
          <p
            className="medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문번호
          </p>
          <p
            className="medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            주문 일시
          </p>
          <p
            className="medium-text"
            style={{ fontSize: "14px", color: "#888888" }}
          >
            결제수단
          </p>
          {order_item_list[0]?.payStatus === "ready" && (
            <p
              style={{ color: "#f25c5c", cursor: "pointer" }}
              onClick={() => setClickCancelOrder(true)}
            >
              주문취소
            </p>
          )}
          {order_item_list[0]?.payStatus === "paid" && (
            <p
              style={{ color: "#f25c5c", cursor: "pointer" }}
              onClick={() => setClickRefund(true)}
            >
              환불요청
            </p>
          )}
        </div>
        <div
          style={{
            marginTop: "14px",
            display: "grid",
            gridTemplateColumns: "151px 40px 179px 396px 59px",
          }}
        >
          <div className="scrollName">
            <p style={{ whiteSpace: "no-wrap" }}>{orderInfo.orderId}</p>
          </div>
          <div />
          <p>{orderInfo.regTime}</p>
          <p>
            {orderInfo.payMethod === "trans"
              ? "무통장입금"
              : orderInfo.payMethod === "card"
              ? "신용카드"
              : "가상계좌"}
          </p>
        </div>

        <div
          className="list_titleBar"
          style={{
            gridTemplateColumns: "300px 140px 385px",
            height: "44px",
            width: "auto",
            marginTop: "40px",
          }}
        >
          <p className="leftalign">기프티콘</p>
          <p className="leftalign">주문 수량</p>
          <p className="leftalign">주문 금액</p>
        </div>

        {order_item_list.map((data) => (
          <div
            key={data.orderItemId}
            className="list_contentBar"
            style={{
              width: "auto",
              height: "61px",
              gridTemplateColumns: "300px 140px 326px 59px",
            }}
          >
            <p className="leftalign">{data.goodsName}</p>
            <p className="leftalign">{data.quantity?.toLocaleString()}개</p>
            <p className="leftalign">{data.totalAmount?.toLocaleString()}원</p>
            <div className="center">
              <p
                className="medium-text"
                style={{
                  color: data.payStatus === "환불완료" ? "#1167ed" : "#b0b0b0",
                  fontSize: "14px",
                }}
              >
                {data.payStatus === "failed"
                  ? "취소완료"
                  : data.refundStatus !== "정상"
                  ? data.refundStatus
                  : ""}
              </p>
            </div>
          </div>
        ))}
        <Pagination
          totalPages={total_item === 0 ? 1 : Math.ceil(total_item / 5)}
          currentPage={page}
          onPageChange={(pageNum) => setPage(pageNum)}
        />

        {order_item_list[0]?.payStatus === "ready" && (
          <div
            className="grayBox"
            style={{
              marginTop: "40px",
              padding: "30px",
            }}
          >
            <p className="bold-text">입금 정보</p>
            <p style={{ color: "#000000", marginTop: "14px" }}>
              입금처 : 농협은행 / 301-0327-0214-21 / 주식회사 러닝포인트
            </p>
            <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
              <p style={{ color: "#555555" }}>입금 기한</p>
              <p className="medium-text" style={{ marginLeft: "auto" }}>
                {orderInfo.transferLimitTime}
              </p>
            </div>
            <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
              <p style={{ color: "#555555" }}>입금자명</p>
              <p className="medium-text" style={{ marginLeft: "auto" }}>
                {orderInfo.transferUsername}
              </p>
            </div>
            <p style={{ marginTop: "14px", color: "#f25c5c" }}>
              *주문 후 72시간 내 미입금시 주문 자동 취소
            </p>

            <hr
              color="#e4e4e4"
              style={{
                margin: "30px 0",
                border: 0,
                height: "1px",
              }}
            />

            <div className="hrz-wrapper">
              <p className="bold-text">현금영수증 정보</p>
              <div
                className="center"
                style={{
                  marginLeft: "auto",
                  width: "75px",
                  height: "36px",
                  borderRadius: "8px",
                  boxShadow: "inset 0 0 0 1px #707070",
                  cursor: "pointer",
                }}
                onClick={() => setClickUpdateCashInfo(true)}
              >
                <p
                  className="medium-text"
                  style={{ fontSize: "14px", color: "#707070" }}
                >
                  정보 수정
                </p>
              </div>
            </div>
            <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
              <p style={{ color: "#555555" }}>사업자번호</p>
              <p className="medium-text" style={{ marginLeft: "auto" }}>
                {orderInfo.cashNo}
              </p>
            </div>
            <div className="hrz-wrapper" style={{ marginTop: "14px" }}>
              <p style={{ color: "#555555" }}>이메일</p>
              <p className="medium-text" style={{ marginLeft: "auto" }}>
                {orderInfo.cashEmail}
              </p>
            </div>
          </div>
        )}
      </div>
    </Box>
  );
};

const OrderInfo = ({ handleClickX, paymentId }) => {
  return (
    <LayoutModal
      Modal={<OrderInfoBox handleClickX={handleClickX} paymentId={paymentId} />}
    />
  );
};

const Box = styled.div`
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

export default OrderInfo;
